/* Shared by HospitalsHero, UniversitiesHero and ProvidersHero.
   Import this one module into all three components. */

.heroRoot {
  position: relative;
}

@keyframes cbDraw {
  from { stroke-dashoffset: 1200; }
  to { stroke-dashoffset: 0; }
}
@keyframes cbRise {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: none; }
}
@keyframes cbFill {
  from { width: 0; }
}

/* Animations are inert until the root has .playing — see useHeroInView.
   This is the one change from the original mockup: there, these
   classes animated unconditionally on mount. */
.draw {
  stroke-dasharray: 1200;
  stroke-dashoffset: 1200; /* hidden until .playing starts the draw-in */
}
.heroRoot.playing .draw {
  animation: cbDraw 1.4s cubic-bezier(.6, 0, .2, 1) both;
}

.rise1 { opacity: 0; }
.rise2 { opacity: 0; }
.rise3 { opacity: 0; }
.heroRoot.playing .rise1 { animation: cbRise .7s .5s ease-out both; }
.heroRoot.playing .rise2 { animation: cbRise .7s .8s ease-out both; }
.heroRoot.playing .rise3 { animation: cbRise .7s 1.1s ease-out both; }

.heroRoot.playing .fill {
  animation: cbFill 1.6s 1s ease-out both;
}

@media (prefers-reduced-motion: reduce) {
  .heroRoot.playing .draw,
  .heroRoot.playing .rise1,
  .heroRoot.playing .rise2,
  .heroRoot.playing .rise3,
  .heroRoot.playing .fill {
    animation: none;
  }
  .rise1, .rise2, .rise3 { opacity: 1; }
  .draw { stroke-dashoffset: 0; }
}
